// src/api.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

console.log("🔧 API_BASE configured as:", API_BASE);

// Send cookies by default (server uses httpOnly cookies for auth)
axios.defaults.withCredentials = true;

export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const login = async (username, password) => {
  // server sets httpOnly cookie; client just triggers login
  const res = await axios.post(
    `${API_BASE}/admin/login`,
    { username, password },
    { withCredentials: true }
  );
  return res.data;
};

export const getCurrentAdmin = async () => {
  const res = await axios.get(`${API_BASE}/admin/me`, {
    withCredentials: true,
  });
  return res.data;
};

export const logout = async () => {
  // Clear cookie by calling an optional logout endpoint or client-side removal if not available
  try {
    await axios.post(`${API_BASE}/admin/logout`, {}, { withCredentials: true });
  } catch (e) {
    // ignore
  }
};

export const changePassword = async (newPassword) => {
  const res = await axios.post(
    `${API_BASE}/admin/change-password`,
    { new_password: newPassword },
    { withCredentials: true }
  );
  return res.data;
};

// GET /team/{locationSlug}
export const getTeam = async (locationSlug) => {
  const res = await axios.get(`${API_BASE}/team/${locationSlug}`);
  return res.data;
};

// POST /team
export const addTeamMember = async (member) => {
  const res = await axios.post(`${API_BASE}/team`, member);
  return res.data;
};

// PUT /team/{id}
export const updateTeamMember = async (id, member) => {
  const res = await axios.put(`${API_BASE}/team/${id}`, member);
  return res.data;
};

// DELETE /team/{id}
export const deleteTeamMember = async (id) => {
  const res = await axios.delete(`${API_BASE}/team/${id}`);
  return res.data;
};

// --- Content blocks ---
export const getContent = async (locationSlug) => {
  const res = await axios.get(`${API_BASE}/content/${locationSlug}`);
  return res.data;
};

export const updateContent = async (locationSlug, content) => {
  const res = await axios.put(`${API_BASE}/content/${locationSlug}`, content);
  return res.data;
};

// --- Gallery ---
export const getGallery = async (locationSlug) => {
  const res = await axios.get(`${API_BASE}/gallery/${locationSlug}`);
  return res.data;
};

export const addGalleryImage = async (locationSlug, image) => {
  const res = await axios.post(`${API_BASE}/gallery/${locationSlug}`, image);
  return res.data;
};

export const uploadGalleryImage = async (locationSlug, file, alt) => {
  const form = new FormData();
  form.append("file", file);
  form.append("alt", alt || "");
  const res = await axios.post(
    `${API_BASE}/gallery/${locationSlug}/upload`,
    form,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return res.data;
};

// Generic file upload that returns { url }
export const uploadFile = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API_BASE}/uploads/file`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteGalleryImage = async (locationSlug, imageId) => {
  const res = await axios.delete(
    `${API_BASE}/gallery/${locationSlug}/${imageId}`
  );
  return res.data;
};

// --- Locations ---
export const getLocations = async () => {
  const res = await axios.get(`${API_BASE}/locations`);
  return res.data;
};

export const getLocation = async (slug) => {
  const res = await axios.get(`${API_BASE}/locations/${slug}`);
  return res.data;
};

export const updateLocation = async (slug, location) => {
  const res = await axios.put(`${API_BASE}/locations/${slug}`, location, {
    withCredentials: true,
  });
  return res.data;
};

// --- Contact ---
export const sendContactMessage = async (contactData) => {
  const res = await axios.post(`${API_BASE}/contact`, contactData);
  return res.data;
};

// --- Sessions ---
export const getSessionInfo = async (locationSlug) => {
  const res = await axios.get(`${API_BASE}/sessions/${locationSlug}`);
  return res.data;
};

export const updateSessionInfo = async (locationSlug, sessionData) => {
  const res = await axios.put(`${API_BASE}/sessions/${locationSlug}`, sessionData, {
    withCredentials: true,
  });
  return res.data;
};
